const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIconRProgressDispatchedInverse(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "100%",
    height: "100%",
    viewBox: "0 0 30 30",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    xmlSpace: "preserve",
    xmlnsserif: "http://www.serif.com/",
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      strokeLinejoin: "round",
      strokeMiterlimit: 2
    },
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("rect", {
    id: "iconR-progress-dispatched-inverse",
    x: 0,
    y: 0,
    width: 30,
    height: 30,
    style: {
      fill: "none"
    }
  }), /*#__PURE__*/React.createElement("g", {
    id: "iconR-progress-dispatched-inverse1",
    serifid: "iconR-progress-dispatched-inverse"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M15,1c7.727,0 14,6.273 14,14c0,7.727 -6.273,14 -14,14c-7.727,0 -14,-6.273 -14,-14c0,-7.727 6.273,-14 14,-14Zm0,2.181c6.523,-0 11.819,5.296 11.819,11.819c0,6.523 -5.296,11.819 -11.819,11.819c-6.523,0 -11.819,-5.296 -11.819,-11.819c-0,-6.523 5.296,-11.819 11.819,-11.819Z",
    style: {
      fill: "#fff",
      fillOpacity: 0.36
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15,2.135l0,0.013c0.001,0.577 0.449,1.055 1.025,1.091c6.048,0.505 10.794,5.579 10.794,11.761c0,6.523 -5.296,11.819 -11.819,11.819c-6.523,0 -11.819,-5.296 -11.819,-11.819c-0,-1.741 0.384,-3.456 1.121,-5.025c0.245,-0.504 0.063,-1.119 -0.413,-1.41l-0.023,-0.014c-0.262,-0.152 -0.577,-0.189 -0.867,-0.1c-0.291,0.088 -0.531,0.294 -0.664,0.567c-0.875,1.868 -1.335,3.91 -1.335,5.982c0,7.727 6.273,14 14,14c7.727,-0 14,-6.273 14,-14c0,-7.342 -5.652,-13.364 -12.842,-13.953c-0.297,-0.018 -0.588,0.088 -0.804,0.292c-0.213,0.201 -0.35,0.502 -0.354,0.796Zm1.283,18.076c0.196,0.195 0.466,0.316 0.764,0.316c0.299,0 0.57,-0.121 0.765,-0.317l4.446,-4.445c0.196,-0.196 0.317,-0.466 0.317,-0.765c-0,-0.299 -0.121,-0.569 -0.317,-0.765l-4.446,-4.445c-0.195,-0.196 -0.466,-0.317 -0.765,-0.317c-0.597,-0 -1.082,0.484 -1.082,1.082c0,0.298 0.122,0.569 0.317,0.764c0,0 2.599,2.599 2.599,2.599c0,0 -10.374,0 -10.374,0c-0.597,0 -1.082,0.485 -1.082,1.082c0,0.597 0.485,1.082 1.082,1.082l10.374,-0l-2.599,2.599c-0.195,0.195 -0.316,0.466 -0.316,0.765c-0,0.298 0.121,0.569 0.316,0.764l0.001,0.001Z",
    style: {
      fill: "#fff"
    }
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconRProgressDispatchedInverse);
export default __webpack_public_path__ + "static/media/iconR-progress-dispatched-inverse.95273f8ae5fe6607626339924f79ffe9.svg";
export { ForwardRef as ReactComponent };